import React from 'react';
import NABHImage from '../../assets/NABH/NABH.png';
import './NABH.css';

const NABH = () => {
    return (
        <div className="nabh-wrapper">
            <img src={NABHImage} alt="NABH Accreditation" className="nabh-img" />
        </div>
    );
};

export default NABH;
